import { EnumQuoteType } from "../enum/enum-quote-type";
import {EnumClientSize} from "../enum/enum-client-size";
import { EmployeeRoleEnum } from "../employee/employee-role.enum";
import { EnumOpportunityType } from "../enum/enum-opportunity-type";

export class ProductsByServicesRequest {
    public role?: string
    public country?: string
    public codesByService?: Record<string, string[]>;
    public cmcProtocolCode?: string;
    public type?: EnumQuoteType;
    public market: string;
    public subMarket: string;
    public size?: EnumClientSize;
    public productPricingType?: EnumOpportunityType;
    public extinctionArticlesIncluded?: boolean;

    initByCountryAndRole(countryIsoCode: string, role: EmployeeRoleEnum, market, subMarket, size: EnumClientSize, type: EnumQuoteType, opportunityType: EnumOpportunityType, cmcProtocolCode: string, extinctionArticlesIncluded: boolean) {
        this.country = countryIsoCode;
        this.type = type;
        this.role = role.pricingRole;
        this.market = market;
        this.subMarket = subMarket;
        this.size = size;
        this.codesByService = {};
        this.productPricingType = opportunityType;
        this.cmcProtocolCode = cmcProtocolCode;
        this.extinctionArticlesIncluded = extinctionArticlesIncluded;
    }
}

